/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteTile} from '../api'

export const useMutationDeleteTile = createReactQueryMutationHook('deleteTile', deleteTile)
